<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="改善任务id" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input readOnly v-decorator="[ 'improveId', validatorRules.improveId]" placeholder="请输入改善任务id"></a-input>
        </a-form-item>
        <a-form-item label="投诉人编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input readOnly v-decorator="[ 'userNo', validatorRules.userNo]" placeholder="请输入投诉人编号"></a-input>
        </a-form-item>
        <a-form-item label="投诉人名字" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input readOnly v-decorator="[ 'userName', validatorRules.userName]" placeholder="请输入投诉人名字"></a-input>
        </a-form-item>
        <a-form-item label="被投诉人姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input readOnly v-decorator="[ 'targetUserName', validatorRules.targetUserName]" placeholder="请输入被投诉人姓名"></a-input>
        </a-form-item>
        <a-form-item label="被投诉人编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input readOnly v-decorator="[ 'targetUserNo', validatorRules.targetUserNo]" placeholder="请输入被投诉人编码"></a-input>
        </a-form-item>
        <a-form-item label="投诉原因" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input readOnly v-decorator="[ 'remarks', validatorRules.remarks]" placeholder="请输入投诉原因"></a-input>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'

  export default {
    name: "BusInspectionComplaintModal",
    components: { 
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          improveId: {rules: [
          ]},
          userNo: {rules: [
          ]},
          userName: {rules: [
          ]},
          targetUserName: {rules: [
          ]},
          targetUserNo: {rules: [
          ]},
          remarks: {rules: [
          ]},
        },
        url: {
          add: "/general/complaint/busInspectionComplaint/add",
          edit: "/general/complaint/busInspectionComplaint/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'improveId','userNo','userName','targetUserName','targetUserNo','remarks'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'improveId','userNo','userName','targetUserName','targetUserNo','remarks'))
      },

      
    }
  }
</script>